import React from "react";

export default function PatientDashboardPage() {
  return (
    <div style={{ padding: "40px" }}>
      <h1>This is Patient Dashboard</h1>
    </div>
  );
}